
'use strict';

angular.module('app')
  .service('checkoutDrService', function (Request, info, utils, $routeParams) {
    return {
      getResortProducts: function (data, shopCurrency) {
        return Request.get('booking/resort/' + $routeParams.slug + '/rooms/', data).then(function (res) {
          var guests = 0;
          console.log('YBOATA', data)
          if (data.guests instanceof Array) {
            _.each(data.guests, function (val) {
              guests += val;
            });
          } else {
            guests = data.guests;
          }
          _.each(res.data, function (val) {
            val.dateFrom = data.date_0;
            val.dateTo = data.dateTo;
            val.duration = data.nights;

            if (!val.packages) {
              val.groupedRates = _.groupBy(val.rates, 'mealPlan');

              val.rates = [];

              _.each(val.groupedRates, function (v) {
                var minPrice = _.min(v, 'ratePrice'),
                  maxComparePrice = _.max(v, 'compareRatePrice');

                minPrice.compareRatePrice = maxComparePrice.compareRatePrice;
                minPrice.personCompareRatePrice = minPrice.compareRatePrice / guests;
                minPrice.personRatePrice = minPrice.ratePrice / guests;

                val.rates.push(minPrice);
              });

              val.rates = _.sortBy(val.rates, 'ratePrice');

              if (val.rates && val.rates.length && val.showRates) {
                val.minimalPrice = +val.rates[0].ratePrice;
              }
            } else {
              val.isPackage = true;
              val.rates = _(val.packages).map(function (pack, key) {
                pack.mealPlan = +key;
                pack.ratePrice = pack.price;

                if (!val.showRates && pack.ids && pack.ids.length && !pack.exceptions.length) {
                  val.showRates = true;
                }

                if (pack.exceptions && pack.exceptions.length) {
                  val.exceptionMessage = pack.exceptions[0];
                }

                if (pack.mealPlan && pack.ratePrice && !pack.exceptions.length) {
                  pack.personRatePrice = pack.price / guests;

                  return pack;
                }
              }).filter(function (pack) { return pack; }).value();
              val.packageDiveKind = _.get(val.rates, '[0].packageDiveKind'); // remove this line when BE will send it in a normal way
              val.divesAmount = val.packages.dives;

              val.diveCenterInclusions = val.packages.diverInclusions;
              val.resortRoomInclusions = val.packages.nondiverInclusions;
            }
          });

          return _.sortBy(res.data, 'minimalPrice');
        });
      },
      getPackagesData: function (data) {
        return Request.get('booking/resort/' + $routeParams.slug + '/packages-data/', data).then(function (res) {
          var pricesData = [],
            groupedPricesData = _(res.data).map(function (val) { return val.pricesData; }).flatten().groupBy('date').value();

          _.each(groupedPricesData, function (data) {
            var dateObj = { date: data[0].date, allowedLength: [] };

            _.each(data, function (day, i) {
              dateObj.allowedLength = _.uniq(dateObj.allowedLength.concat(day.allowedLength));

              if (_.isNull(day.itemsLeft) === false) {
                if (!dateObj.itemsLeft) {
                  dateObj.itemsLeft = 0;
                }

                dateObj.itemsLeft += day.itemsLeft;
              }
            });

            pricesData.push(dateObj);
          });
          return pricesData;
        });
      },
      getResortMealPlans: function () {
        return Request.get('booking/resort/' + $routeParams.slug + '/meal-plans/').then(function (res) {
          return res.data;
        });
      },
      getResortAvailability: function (filter) {
        return Request.get('booking/resort/' + $routeParams.slug + '/rooms/availability/', filter).then(function (res) {
          return res.data;
        });
      },
      getPricingDetails: function (roomId, filter) {
        return Request.get('booking/resort/checkout/' + roomId + '/data/', filter).then(function (res) {
          var val = res.data[0];

          if (val.packages) {
            val.isPackage = true;
            val.rates = _(val.packages).map(function (pack, key) {
              pack.mealPlan = +key;
              pack.ratePrice = pack.price;

              if (!val.showRates && pack.ids && pack.ids.length) {
                val.showRates = true;
              }

              if (pack.mealPlan && pack.ratePrice && !pack.exceptions.length) {
                return pack;
              }
            }).filter(function (pack) { return pack; }).value();

            val.packageDiveKind = _.get(val.rates, '[0].packageDiveKind');
            val.divesAmount = val.packages.dives;

            val.diveCenterInclusions = val.packages.diverInclusions;
            val.resortRoomInclusions = val.packages.nondiverInclusions;
          }

          return res.data;
        });
      },
      getDivesPricing: function (roomId, rateId) {
        return Request.get('booking/resort/' + $routeParams.slug + '/base-product/').then(function (res) {
          return res.data;
        });
      },

      getInclusions: function (data, details) {
        var numberOfDivers = details.divers,
          numberOfNonDivers = details.nonDivers,
          numberOfStudents = details.students,
          numberOfGuests = numberOfDivers + numberOfNonDivers + numberOfStudents,
          duration = details.duration,
          numberOfRooms = details.rooms,
          numberOfDives = details.numberOfDives,
          _this = this;
          console.log(details)

        return Request.get('booking/resort/inclusions/' + (data.slug || $routeParams.slug) + '/checkout/', data).then(function (res) {
          var inclusions = _(res.data).filter(function (val) {
            val = _this.setCourseType(val);
            if (val.isMandatory || val.isIncluded) {
              if (utils.isBelongsTo(val.belongsTo, 'DC Extras & Surcharge') || utils.isBelongsTo(val.belongsTo, 'Rental equipment')) {
                val.qty = _this.setLimit(val, numberOfDives, duration, numberOfRooms, numberOfGuests, numberOfDivers, numberOfStudents, numberOfNonDivers);
              }
            }

            return val.isBookableInAdvance && val.pricingId && ((val.isIncluded && !val.isMandatory) || (val.payedInAdvance && val.price) || (val.payedInAdvance === false && (val.price || val.extraValue)));
          });

          return {
            groupedInclusions: inclusions.sortByAll(['isMandatory', 'isIncluded']).groupBy('belongsTo').value(),
            inclusions: inclusions.value(),
          };
        });
      },
      setLimit: function (course, numberOfDives, duration, numberOfRooms, numberOfGuests, numberOfDivers, numberOfStudents, numberOfNonDivers) {
        var limit = 1,
          notDiverProducts = !utils.isBelongsTo(course.belongsTo, 'DC Extras & Surcharge') && !utils.isBelongsTo(course.belongsTo, 'Rental equipment');

        duration = +duration;

        function setMaximumLimitOfItem(lim, item) {
          if (item.isDiverItem) {
            lim *= numberOfDivers;
          } else if (item.isNonDiverItem) {
            lim *= numberOfNonDivers;
          } else if (item.isStudentItem) {
            lim *= numberOfStudents;
          }

          return lim;
        }

        switch (+course.payedPer) {
        // Per Day
        case 0:
          limit = duration + 1;

          if (course.packageKind) {
            limit = setMaximumLimitOfItem(limit, course);
          } else if (notDiverProducts) {
            limit *= numberOfGuests;
          }
          break;
          // Day/room
        case 5:
          limit = (duration + 1) * numberOfRooms;
          break;
          // Per Night
        case 10:
          limit = duration;

          if (course.packageKind) {
            limit = setMaximumLimitOfItem(limit, course);
          } else if (notDiverProducts) {
            limit *= numberOfGuests;
          }
          break;
          // Per Night/room
        case 15:
          limit = duration * numberOfRooms;
          break;
          // Per Dive
        case 20:
          limit = numberOfDives;

          break;
          // Per Trip
        case 30:
          limit = 1;
          break;
          // Per Diving day
        case 40:
          limit = duration - 1;

          if (notDiverProducts) {
            limit *= numberOfDivers;
          }

          break;
          // note: 50 is old payedPer code, don't know if it's used
        case 50:
          limit = 1;

          if (course.packageKind) {
            limit = setMaximumLimitOfItem(limit, course);
          } else if (notDiverProducts) {
            limit *= numberOfGuests;
          }

          break;
          // Transfer Per Vehicle
        case 52:
        case 54:
        case 57:
          limit = 1;
          break;
          // Transfer Per Person
        case 51:
        case 53:
        case 56:
          limit = 1;

          if (course.packageKind) {
            limit = setMaximumLimitOfItem(limit, course);
          } else if (notDiverProducts) {
            limit *= numberOfGuests;
          }

          break;
          // note: 55 is old payedPer code, don't know if it's used
        case 55:
          limit = 1;

          if (course.packageKind) {
            limit = setMaximumLimitOfItem(limit, course);
          } else if (notDiverProducts) {
            limit *= numberOfGuests;
          }

          break;
          // Per Stay
        case 60:
          limit = 1;

          if (course.packageKind) {
            limit = setMaximumLimitOfItem(limit, course);
          } else if (notDiverProducts) {
            limit *= numberOfGuests;
          }
          break;
          // Per activity
        case 65:
          limit = 1;

          if (course.packageKind) {
            limit = setMaximumLimitOfItem(limit, course);
          } else if (notDiverProducts) {
            limit *= numberOfGuests;
          }
          break;
          // N/A
        case 70:
          limit = 1;
          break;
        }
        return limit;
      },
      setCourseType: function (item) {
        if (item.packageKind === 10) {
          item.isDiverItem = true;
        } else if (item.packageKind === 20) {
          item.isNonDiverItem = true;
        } else if (item.packageKind === 40) {
          item.isStudentItem = true;
        }

        return item;
      },
      getDiveCourses: function () {
        return Request.get('shop/' + $routeParams.slug + '/products/').then(function (res) {
          _.each(res.data, function (val) {
            val.isCourse = true;

            if (val.pricing) {
              val.pricingId =  val.pricing.id;
              val.priceGross = val.pricing.priceGross;
            }
          });
          return res.data;
        });
      },
      getShopInfo: function (slug) {
        return Request.get('booking/resort/checkout/' + slug + '/').then(function (res) {
          return res.data;
        });
      },
      additionalPriceText: function (diver, divePrices, currency) {
        var text = ' +',
          add = true,
          includedPrice = _.find(divePrices.prices, { numberOfInstances: diver.divesIncluded })._perDiveSetPriceGross,
          currentPrice = _.find(divePrices.prices, { numberOfInstances: diver.numberOfDives }),
          // additionalDivePrice = _.find(divePrices.prices, { numberOfInstances: 21 }),
          pricingObject = {
            diverNumber: diver.key,
            pricing: currentPrice.id,
            quantity: 1,
          },
          additionalPricingObject,
          price = Math.abs(currentPrice._perDiveSetPriceGross - includedPrice);

        if (diver.numberOfDives < diver.divesIncluded) {
          text = ' -';
          add = false;
        }

        // if (diver.numberOfDives > 20) {
        //     var additionalDivesNumber = diver.numberOfDives - 20;

        //     if (diver.isTwoTank) {
        //         additionalDivesNumber = additionalDivesNumber / 2
        //     }


        //     additionalPricingObject = {
        //         diverNumber: diver.key,
        //         pricing: additionalDivePrice.id,
        //         quantity: additionalDivesNumber
        //     }

        //     for(var i = additionalDivesNumber; i > 0; i--) {
        //         price += additionalDivePrice._pricePerAddDiveGross;
        //     }
        // }

        return {
          price: price,
          // convertedPrice: $rootScope.setValue(price, divePrices.currency, true, currency),
          // currency: divePrices.currency,
          add: add,
          text: text,
          pricingObject: pricingObject,
          additionalPricingObject: additionalPricingObject,
        };
      },
      calculatePricingWithTaxes: function (taxesIncluded, price, tax) {
        var priceWithoutTaxes, taxAmount;
        if (taxesIncluded) {
          taxAmount = price / (1 + tax / 100);
          priceWithoutTaxes = price - taxAmount;
        } else {
          taxAmount = price * (tax / 100);
        }

        return {
          priceWithoutTaxes: priceWithoutTaxes,
          taxAmount: taxAmount,
        };
      },
    };
  });
